import i18n, { loadLanguage } from './index';
import { DEFAULT_LOCALE } from './config';
import { applyDocumentLang, readStoredLocale } from './storage';
import { loadDateFnsLocale } from '@/lib/dateFnsLocale';

/**
 * Sprache vor dem ersten Render herstellen.
 *
 * Deutsch ist statisch gebündelt → löst in einem Microtask auf (kein Flash).
 * Jeder Fehler wird verschluckt: die App startet notfalls auf Deutsch,
 * niemals gar nicht.
 */
export async function bootstrapI18n(): Promise<void> {
  const lng = readStoredLocale();

  if (lng !== DEFAULT_LOCALE) {
    try {
      const ok = await loadLanguage(lng);
      if (ok) await i18n.changeLanguage(lng);
    } catch (e) {
      console.warn('[i18n] Sprache konnte nicht geladen werden, bleibe bei Deutsch', e);
    }
  }

  try {
    await loadDateFnsLocale(i18n.language);
  } catch {
    /* date-fns bleibt auf Deutsch */
  }

  applyDocumentLang(i18n.language);
}
